// Source: app/scripts/router.js
/**
 * @ngdoc here we are configuring the module exposed through the Auction
 *        variable. The method receives an array that has a function as a last
 *        argument. Here, the angular inject the dependencies defined as strings
 *        in the array to the corresponding elements in the function. <br/> The
 *        $routeProvider is used to configure the routes. It maps templateUrl
 *        and optionally a controller to a given path. This is used by the
 *        ng-view directive. It replaces the content of the defining element
 *        with the content of the templateUrl, and connects it to the controller
 *        through the $scope.
 * @see https://docs.angularjs.org/guide/di
 */
Auction.config(['$routeProvider', 'settings', function ($routeProvider, settings) {
  var version = settings.version;

  $routeProvider.when('/', {
    templateUrl: 'views/general_home_page.html?version=' + version,
    controller: 'PublishedAuctionsController',
    publicAccess: true
  });

  $routeProvider.when('/ecounter_home', {
    templateUrl: 'views/ecounter_home_page.html?version=' + version,
    controller: 'PublishedAuctionsController',
    publicAccess: true
  });
  $routeProvider.when('/web_portal/ecounter_home', {
    templateUrl: 'views/ecounter_home_page.html?version=' + version,
    controller: 'PublishedAuctionsController',
    publicAccess: true
  });

  $routeProvider.when('/eauction_home', {
    templateUrl: 'views/eauction_home.html?version=' + version,
    controller: 'EAuctionHomeController',
    publicAccess: true
  });

  $routeProvider.when('/login', {
    templateUrl: 'views/login.html?version=' + version,
    controller: 'LoginController',
    publicAccess: true
  }).when('/login-mfa', {
    templateUrl: 'views/login-mfa.html?version=' + version,
    controller: 'LoginMfaController',
    publicAccess: true
  }).when('/forgotten_password', {
    templateUrl: 'views/forgotten_password.html?version=' + version,
    controller: 'LoginController',
    publicAccess: true
  }).when('/expired_password', {
    templateUrl: 'views/expired_password.html?version=' + version,
    controller: 'LoginController',
    publicAccess: true
  }).when('/register_person', {
    templateUrl: 'views/register_person.html?version=' + version,
    controller: 'RegisterPersonController',
    publicAccess: true
  }).when('/register_trader', {
    templateUrl: 'views/register_trader.html?version=' + version,
    controller: 'RegisterTraderController',
    publicAccess: true
  }).when('/subcategory/:id/products', {
    templateUrl: 'views/products.html?version=' + version,
    controller: 'SubcategoryProductsController',
    publicAccess: true
  }).when('/forgotten_username', {
    templateUrl: 'views/forgotten_username.html?version=' + version,
    controller: 'LoginController',
    publicAccess: true
  });

  $routeProvider.when('/user/profile', {
    templateUrl: 'views/user/profile.html?version=' + version,
    controller: 'UserProfileController',
  }).when('/user/user-bank-guarantee', {
    templateUrl: 'views/user/user-bank-guarantee.html?version=' + version,
    controller: 'BankGuaranteeController'
  }).when('/user/company_users', {
    templateUrl: 'views/user/company-users.html',
    controller: 'CompanyUsersController'
  }).when('/user/company_signature', {
    templateUrl: 'views/user/company_signature.html?version=' + version,
    controller: 'CompanySignatureController'
  }).when('/user/company_stamp', {
    templateUrl: 'views/user/company_stamp.html?version=' + version,
    controller: 'CompanyStampController'
  });

  $routeProvider.when('/user_auctions/published_auctions', {
    templateUrl: 'views/user_auctions/published_auctions.html?version=' + version,
    controller: 'PublishedAuctionsController',
    publicAccess: true
  }).when('/user_auctions/auction/:auctionId', {
    templateUrl: 'views/user_auctions/auction_lots.html?version=' + version,
    controller: 'AuctionLotRegistrationController',
    publicAccess: true
  }).when('/user_auctions/lot/:auctionId/:lotId', {
    templateUrl: 'views/user_auctions/lot_display.html?version=' + version,
    controller: 'LotDetailsController',
    publicAccess: true
  }).when('/user_auctions/running_auctions', {
    templateUrl: 'views/user_auctions/running_auctions.html?version=' + version,
    controller: 'PublishedAuctionsController',
    publicAccess: true
  }).when('/user_auctions/finished_auctions', {
    templateUrl: 'views/user_auctions/finished_auctions.html?version=' + version,
    controller: 'PublishedAuctionsController',
    publicAccess: true
  }).when('/user_auctions/available_products', {
    templateUrl: 'views/products.html?version=' + version,
    controller: 'SubcategoryProductsController',
    publicAccess: true
  }).when('/user_auctions/requests/:id?', {
    templateUrl: 'views/user_auctions/requests.html?version=' + version,
    controller: 'AuctionParticipationRequestController'
  }).when('/user_auctions/auction_bid/:auctionId', {
    templateUrl: 'views/user_auctions/auction_bidding.html?version=' + version,
    controller: 'AuctionBiddingController',
    publicAccess: true
  }).when('/user_auctions/eauction_home', {
    templateUrl: 'views/eauction_home.html?version=' + version,
    controller: 'EAuctionHomeController',
    publicAccess: true
  }).when('/user_auctions/eauction_home_page', {
    templateUrl: 'views/eauction_home.html?version=' + version,
    controller: 'EAuctionHomeController',
    publicAccess: true
  });



  $routeProvider.when('/user_info/contact_:lang', {
    templateUrl: 'views/user_info/contact.html?version=' + version,
    publicAccess: true
  }).when('/user_info/help', {
    templateUrl: 'views/user_info/help.html?version=' + version,
    controller: 'ActivePageContentController',
    publicAccess: true
  }).when('/user_info/terms_:lang', {
    templateUrl: 'views/user_info/terms.html?version=' + version,
    controller: 'ActivePageContentController',
    publicAccess: true
  }).when('/user_info/privacy_policy_:lang', {
    templateUrl: 'views/user_info/privacy_policy.html?version=' + version,
    controller: 'ActivePageContentController',
    publicAccess: true
  }).when('/user_info/faq_:lang', {
    templateUrl: 'views/user_info/faq.html?version=' + version,
    controller: 'ActivePageContentController',
    publicAccess: true
  });
  // $routeProvider.when('/admin/auth/pages', {
  //     templateUrl: 'views/pages.html?version='+version
  // });

  $routeProvider.when('/admin/auth/pages/:id?', {
    templateUrl: 'views/admin/auth/pages.html?version=' + version
  }).when('/admin/auth/page_groups/:id?', {
    templateUrl: 'views/admin/auth/page_groups.html?version=' + version,
    controller: 'PageGroupController'
  }).when('/admin/auth/users/:id?', {
    templateUrl: 'views/admin/auth/users.html?version=' + version,
    controller: 'UserController'
  }).when('/admin/auth/mfa_audit', {
    templateUrl: 'views/admin/auth/mfa_audit.html?version=' + version,
    controller: 'MfaAuditController'
  }).when('/admin/auth/user_roles/:id?', {
    templateUrl: 'views/admin/auth/user_roles.html?version=' + version
  }).when('/admin/auth/user_pages/:id?', {
    templateUrl: 'views/admin/auth/user_pages.html?version=' + version
  }).when('/admin/auth/user_role_pages/:id?', {
    templateUrl: 'views/admin/auth/user_role_pages.html?version=' + version
  }).when('/admin/auth/persons/:id?', {
    templateUrl: 'views/admin/auth/persons.html?version=' + version,
    controller: 'PersonController'
  }).when('/admin/auth/traders/:id?', {
    templateUrl: 'views/admin/auth/traders.html?version=' + version,
    controller: 'TraderController'
  }).when('/admin/auth/bank_guarantee/:id?', {
    templateUrl: 'views/admin/auth/bank_guarantee.html?version=' + version,
    controller: 'BankGuaranteeController'
  }).when('/admin/auth/companies_for_approval/:id?', {
    templateUrl: 'views/admin/auth/companies_for_approval.html?version=' + version,
    controller: 'CompaniesForApprovalController'
  }).when('/admin/auth/individuals_for_approval/:id?', {
    templateUrl: 'views/admin/auth/individuals_for_approval.html?version=' + version,
    controller: 'IndividualsForApprovalController'
  });

  $routeProvider.when('/admin/misc/languages/:id?', {
    templateUrl: 'views/admin/misc/languages.html?version=' + version
  }).when('/admin/misc/translations', {
    templateUrl: 'views/admin/misc/translations.html?version=' + version,
    controller: 'TranslationsController'
  }).when('/admin/misc/application_settings', {
    templateUrl: 'views/admin/misc/application_settings.html?version=' + version
  }).when('/admin/misc/application_parameters', {
    templateUrl: 'views/admin/misc/application_parameters.html?version=' + version
  }).when('/admin/misc/tests', {
    templateUrl: 'views/admin/misc/application_settings.html?version=' + version
  }).when('/admin/misc/scheduled_jobs', {
    templateUrl: 'views/admin/misc/scheduled_jobs.html?version=' + version
  }).when('/admin/misc/document_templates', {
    templateUrl: 'views/admin/misc/document_templates.html?version=' + version,
    controller: 'DocumentTemplatesController'
  });

  $routeProvider.when('/admin/vocabularies/measurement_units/:id?', {
    templateUrl: 'views/admin/vocabularies/measurement_units.html?version=' + version
  }).when('/admin/vocabularies/license_types/:id?', {
    templateUrl: 'views/admin/vocabularies/license_types.html?version=' + version
  }).when('/admin/vocabularies/product_categories/:id?', {
    templateUrl: 'views/admin/vocabularies/product_categories.html?version=' + version
  }).when('/admin/vocabularies/product_subcategories/:id?', {
    templateUrl: 'views/admin/vocabularies/product_subcategories.html?version=' + version
  }).when('/admin/vocabularies/quality_types/:id?', {
    templateUrl: 'views/admin/vocabularies/quality_types.html?version=' + version
  }).when('/admin/vocabularies/banks/:id?', {
    templateUrl: 'views/admin/vocabularies/banks.html?version=' + version
  });

  $routeProvider.when('/admin/products/products/:id?', {
    templateUrl: 'views/admin/products/products.html?version=' + version,
    controller: 'ProductController'
  });

  $routeProvider.when('/admin/auctions/auctions/:id?', {
    templateUrl: 'views/admin/auctions/auctions.html?version=' + version,
    controller: 'AuctionController'
  }).when('/admin/auctions/created_auctions/:id?', {
    templateUrl: 'views/admin/auctions/created_auctions.html?version=' + version,
    controller: 'AuctionController'
  }).when('/admin/auctions/lots/:id?', {
    templateUrl: 'views/admin/auctions/lots.html?version=' + version,
    controller: 'LotController'
  }).when('/admin/auctions/auction_participation_requests/:id?', {
    templateUrl: 'views/admin/auctions/requests.html?version=' + version,
    controller: 'AuctionParticipationRequestController'
  }).when('/admin/auctions/republish/:auctionId', {
    templateUrl: 'views/admin/auctions/republish_auction.html?version=' + version,
    controller: 'RepublishAuctionController'
  }).when('/admin/auctions/auction_report/:auctionId', {
    templateUrl: 'views/admin/auctions/auction_report.html?version=' + version,
    controller: 'AuctionReportController'
  }).when('/admin/auctions/bids/:auctionId/:lotId', {
    templateUrl: 'views/admin/auctions/bids.html?version=' + version,
    controller: 'BidsController'
  }).when('/admin/auctions/auction_news/:id?', {
    templateUrl: 'views/admin/auctions/auction_news.html?version=' + version
  });

  $routeProvider.when('/web_portal/web_portal_home_page', {
    templateUrl: 'views/web_portal/web_portal_home_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });
  $routeProvider.when('/web_portal/web_portal_welcome_page', {
    templateUrl: 'views/web_portal/web_portal_welcome_page.html?version=' + version,
    controller: 'WebPortalWelcomePageController'
  });

  $routeProvider.when('/web_portal_administration/case_sub_types', {
    templateUrl: 'views/web_portal/case_sub_types.html?version=' + version
    // controller: 'PublishedAuctionsController',
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/create_general_case', {
    templateUrl: 'views/web_portal/create_general_case_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/create_complain_case', {
    templateUrl: 'views/web_portal/create_complain_case.html?version=' + version,
    controller: 'WebPortalHomePageController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_general_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditGeneralCaseController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_general_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewGeneralCaseController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal_administration/portal_document_types', {
    templateUrl: 'views/web_portal/portal_document_types.html?version=' + version
    // controller: 'PublishedAuctionsController',
    // publicAccess: true
  });
  $routeProvider.when('/web_portal_administration/portal_authorization_types', {
    templateUrl: 'views/web_portal/portal_authorization_types.html?version=' + version,
    controller: 'AuthorizationTypesController',
    // publicAccess: true
  });
  $routeProvider.when('/web_portal_administration/portal_decision_types', {
    templateUrl: 'views/web_portal/portal_decision_types.html?version=' + version
    // controller: 'PublishedAuctionsController',
    // publicAccess: true
  });
  $routeProvider.when('/web_portal_administration/portal_tariff_types', {
    templateUrl: 'views/web_portal/portal_tariff_types.html?version=' + version
    // controller: 'PublishedAuctionsController',
    // publicAccess: true
  });

  $routeProvider.when('/web_portal/web_portal_home_page/create_authorization_case', {
    templateUrl: 'views/web_portal/create_authorization_case.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });

  $routeProvider.when('/web_portal/web_portal_home_page/edit_authorization_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditAuthorizationCaseController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_authorization_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewAuthorizationCaseController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_complaint_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditComplaintCaseController'
    // publicAccess: true
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_complaint_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewComplaintCaseController'
    // publicAccess: true
  });

  $routeProvider.when('/web_portal_administration/portal_goods_types', {
    templateUrl: 'views/web_portal/portal_goods_types.html?version=' + version,
    controller: 'GoodsTypesController',
    // publicAccess: true
  });

  $routeProvider.when('/web_portal_administration/document_templates_and_groups', {
    templateUrl: 'views/web_portal/document_templates_and_groups.html?version=' + version,
    controller: 'DocumentTemplatesAndGroupsController',
    // publicAccess: true
  });

  $routeProvider.when('/web_portal/documents_templates_page', {
    templateUrl: 'views/web_portal/documents_templates_page.html?version=' + version,
    controller: 'DocumentTemplatesPageController',
    publicAccess: true
  });

  $routeProvider.when('/web_portal_administration/office_locations', {
    templateUrl: 'views/web_portal/office_locations.html?version=' + version
    // controller: 'PublishedAuctionsController',
    // publicAccess: true
  });

  $routeProvider.when('/404', {
    templateUrl: '404.html?version=' + version,
    publicAccess: true
  });

  $routeProvider.when('/access_denied', {
    templateUrl: 'views/forbidden.html?version=' + version,
    publicAccess: true
  });
  $routeProvider.otherwise({
    redirectTo: '/'
  });

  $routeProvider.when('/web_portal/web_portal_home_page/create_movement_certificate_case', {
    templateUrl: 'views/web_portal/create_movement_certificate_case_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_movement_certificate_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditMovementCertificateCaseController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_movement_certificate_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewMovementCertificateCaseController'
  });

  $routeProvider.when('/web_portal/web_portal_home_page/create_bti_case', {
    templateUrl: 'views/web_portal/create_bti_case_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_bti_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditBTICaseController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_bti_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewBTICaseController'
  });

  $routeProvider.when('/web_portal/web_portal_home_page/create_ipr_case', {
    templateUrl: 'views/web_portal/create_ipr_case_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_ipr_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditIPRCaseController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_ipr_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewIPRCaseController'
  });

  $routeProvider.when('/web_portal/web_portal_home_page/create_customs_warehouse_case', {
    templateUrl: 'views/web_portal/create_customs_warehouse_case_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_customs_warehouse_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditCustomsWarehouseCaseController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_customs_warehouse_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewCustomsWarehouseCaseController'
  });

  $routeProvider.when('/web_portal/web_portal_home_page/create_simplified_procedure_case', {
    templateUrl: 'views/web_portal/create_simplified_procedure_case_page.html?version=' + version,
    controller: 'WebPortalHomePageController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/edit_simplified_procedure_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'EditSimplifiedProcedureCaseController'
  });
  $routeProvider.when('/web_portal/web_portal_home_page/view_simplified_procedure_case/:id', {
    templateUrl: 'views/web_portal/edit_authorization_case_page.html?version=' + version,
    controller: 'ViewSimplifiedProcedureCaseController'
  });

  $routeProvider.when('/web_portal/movement_certificate_display', {
    templateUrl: 'views/web_portal/movement_certificate_display.html',
    controller: 'MovementCertificateDisplayController',
    publicAccess: true
  });

}]);
